import {asyncType} from '../helpers';

export const transactionsReducerKey = 'transactions';

export default {
   GET_TRANSACTION: asyncType(`${transactionsReducerKey}/GET_TRANSACTION`),
   CREATE_TRANSACTION: asyncType(`${transactionsReducerKey}/CREATE_TRANSACTION`),
   MOVE_TRANSACTION: asyncType(`${transactionsReducerKey}/MOVE_TRANSACTION`),
   GET_REFS_PGP: asyncType(`${transactionsReducerKey}/GET_REFS_PGP`),
   GET_REFS_SSH: asyncType(`${transactionsReducerKey}/GET_REFS_SSH`),
   GET_REFS_SSL: asyncType(`${transactionsReducerKey}/GET_REFS_PGP`),
   GET_REFS_PROXY: asyncType(`${transactionsReducerKey}/GET_REFS_PROXY`),
   GET_REFS_PARTNER: asyncType(`${transactionsReducerKey}/GET_REFS_PARTNER`),
   GET_REFS_TRANSACTION: asyncType(`${transactionsReducerKey}/GET_REFS_TRANSACTION`),
   GET_LINKABLE_TRANSACTIONS: asyncType(`${transactionsReducerKey}/GET_LINKABLA_TRANSACTIONS`),
   GET_TROUBLESHOOTING: asyncType(`${transactionsReducerKey}/GET_TROUBLESHOOTING`),
   TURN_OFF_TROUBLESHOOTING: asyncType(`${transactionsReducerKey}/TURN_OFF_TROUBLESHOOTING`),
   RELEASE_TRANSACTION: asyncType(`${transactionsReducerKey}/RELEASE_TRANSACTION`),
   SUSPEND_TRANSACTION: asyncType(`${transactionsReducerKey}/SUSPEND_TRANSACTION`),
   OPEN_VALIDATE: asyncType(`${transactionsReducerKey}/OPEN_VALIDATE`),
   VALIDATE_TRANSACTION: asyncType(`${transactionsReducerKey}/VALIDATE_TRANSACTION`),
   SEND_TRANSACTION: asyncType(`${transactionsReducerKey}/SEND_TRANSACTION`),
   UPDATE_TRANSACTION: asyncType(`${transactionsReducerKey}/UPDATE_TRANSACTION`),
};
